<template>
    <div class="step">
        <div v-if="currentStep === 0">
            <div
                class="step-circle inactive d-flex justify-content-center align-items-center position-relative rounded-circle">
            </div>
            <div class="step-label custom-label inactive position-absolute text-center">Download Nametag App</div>
        </div>
        <div v-if="currentStep <= 1">
            <div
                class="step-circle inactive d-flex justify-content-center align-items-center position-relative rounded-circle">
            </div>
            <div class="step-label custom-label inactive position-absolute text-center">Redirect to Nametag App</div>
        </div>
        <div v-if="currentStep <= 2">
            <div
                class="step-circle mb-0 inactive d-flex justify-content-center align-items-center position-relative rounded-circle">
            </div>
            <div class="step-label custom-label inactive position-absolute text-center" :style="{ marginTop: '-26px' }">
                Complete Identity Verification</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IdentityVerificationMobileStepper",
    props: {
        currentStep: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style scoped>
.step {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    flex-grow: 1;
    margin-top: 30px;
    margin-left: -37px;
    position: inherit;
}

.step-circle {
    display: block !important;
    width: 30px;
    height: 30px;
    border: 2px solid #ccc;
    background-color: #f0ebeb;
    z-index: 1;
    margin-bottom: 30px;
}

.step-checkmark {
    font-size: 12px;
    color: black;
}

.step-label {
    display: flex !important;
    font-weight: normal;
    white-space: nowrap;
    width: auto;
    font-size: 16px;
    color: gray;
    margin-bottom: 0px !important;
    margin-left: 5px;
    margin-top: -26px;
}

.step-label.active {
    font-weight: bold;
    color: black;
}

.step-label.completed {
    font-weight: 100;
    color: black;
}

.custom-label {
    margin-left: 40px;
    margin-bottom: 100px;
    margin-top: -57px;
}
</style>